import axiosClient from 'lib/axiosClient';
import { useSnackbar } from 'notistack';
import { useState } from 'react';

const useApplicationList = () => {
  const [loading, setLoading] = useState(true);
  const [applicationList, setApplicationList] = useState([]);
  const [pageRef, setPageRef] = useState('');

  const { enqueueSnackbar } = useSnackbar();

  const getApplicationList = (params = {}) => {
    setLoading(true);

    axiosClient
      .get('SettingSystem/Application/List', { params })
      .then(res => {
        if (res.status === 200) {
          setPageRef(res.data.value);

          setApplicationList(prev => {
            const orderedList = res.data.value.list.map(element => ({
              id: element.guid,
              title: element.name,
              key: element.key,
            }));

            return { ...prev, [params?.Page || 1]: orderedList };
          });
        } else {
          enqueueSnackbar(res?.message, { variant: 'error' });
        }
      })
      .catch(err => enqueueSnackbar(err?.message, { variant: 'error' }))
      .finally(() => setLoading(false));
  };

  return [getApplicationList, loading, applicationList, pageRef];
};

export default useApplicationList;
